import React from "react";
import { getPortfolioItem } from "../../api/portfolio/PortfolioData";

import { Container } from "react-bootstrap";
import FadeUpTrigger from "../../animation/FadeUpTrigger";
import TextTrigger from "../../animation/TextTrigger";

//--> Component
import HeaderHalf from "../../components/header/HeaderHalf";
import TitleCover from "../../components/heading/title-cover/TitleCover";
import ButtonProject from "../../components/button/button-project/ButtonProject";
import NextProject from "../../components/next/NextProject";
import BoxRight from "../../components/box-right/BoxRight";
import ParallaxImage from "../../components/parallax-image/ParallaxImage";
import ButtonDefault from "../../components/button/button-default/ButtonDefault";
import BoxImageVertical from "../../components/box-image-vertical/BoxImageVertical";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import DsnGrid from "../../components/DsnGrid";
import { Helmet } from "react-helmet-async";

const Salus = ({ data }) => {
  const nextData = getPortfolioItem(1);

  return (
    <React.Fragment>
      <Helmet>
        <title>Devlift - {data.title} </title>
        <link rel='canonical' href='/portolio/salus' />
        <meta name="description" content={data.description} />
      </Helmet>
      {/*Start Header Half*/}
      <HeaderHalf
        heroContent={data}
        textButton="View Website"
        href="#"
        overlay={data.overlay}
      >
        {/* <strong className="color-heading">Published </strong>{" "}
        <span> - July 15th 2019 </span> */}
      </HeaderHalf>
      {/*End Header Half*/}

      {/*Start Info Project*/}
      <Container className="section-margin">
        <TitleCover>The Ask</TitleCover>
        <TextTrigger duration={0.8} stagger={0.1}>
          {(ref) => (
            <h2 className="title-section" ref={ref}>
              The Ask
            </h2>
          )}
        </TextTrigger>
        <FadeUpTrigger>
          <p className="mt-20">
            Salus Global is a recognized leader in the delivery of innovative solutions for building stronger interprofessional healthcare teams. Working with over 300 hospitals across North America and over 16,000 healthcare professionals, Salus Global has developed a digital platform designed to help improve the core competencies and support the professional career development of healthcare teams. With dated front and back end, Salus Global wanted to redesign their entire learning platform to maintain and enhance existing features and facilitate easier data collection.
          </p>
          {/* <ButtonProject
            className="mt-20"
            href="https://www.behance.net/gallery/37100597/Bastian-Bux?tracking_source=search"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            VISIT SITE{" "}
          </ButtonProject> */}
        </FadeUpTrigger>
      </Container>
      {/*End Info Project*/}
      <Container className="section-margin">
        <DsnGrid
          col={1}
          colGap={50}
          rowGap={50}
          colGapTablet={30}
          rowGapTablet={30}
        >
          <img src="/assets/img/project/salus/salus3.png" alt="" />
        </DsnGrid>
      </Container>
      {/*Start Grid Project*/}

      {/*Start Box Right Info*/}
      {/* <BoxRight
        className="section-margin"
        src="/assets/img/project/salus/thumb.png"
      >
        <FadeUpTrigger>
          {(ref) => (
            <React.Fragment>
              <h2 ref={ref}>
                How is your <br />
                visual identity?
              </h2>

              <p className="mt-30" ref={ref}>
                A system that young people around the world with a club culture
                and techno enthusiasts feel identified. We generated a simple
                logo that is the basis for generating a geometric and liquid
                system.
              </p>
            </React.Fragment>
          )}
        </FadeUpTrigger>
      </BoxRight> */}
      {/*End Box Right Info*/}

      <BoxImageVertical src="/assets/img/project/salus/thumb.png" className="section-margin">
        <FadeUpTrigger>
          {(ref) => <DsnGrid col={1} rowGap={30} rowGapTablet={20}>
            <TitleCover>The Solution</TitleCover>
            <h2 className='title-section border-line-left' ref={ref}>The Solution</h2>
            <p ref={ref}>
              Working together with a local UX firm Res.IM, the main goal was to create a learning platform that was scalable and fit a diverse range of content. With flexible UX patterns that could be applied to different forms of content and learning objectives, the Devlift development team created a number of components that could be reused and adapted.
            </p>
            <p ref={ref}>
              With a complete overhaul of the front-end it was important that it could integrate easily to existing back-end underlying structures, and remain flexible to deliver the necessary learning modules and tools.
            </p>
            <p ref={ref}>
              The Devlift team also introduced enhancements to searching and filtering to help deliver faster, better results when searching through the vast amount of information and learning materials.
            </p>
            {/* <div className="button-box" ref={ref}>
                            <ButtonDefault text="launch" icon={faAngleRight} href="#0"/>
                        </div> */}

          </DsnGrid>}
        </FadeUpTrigger>
      </BoxImageVertical>

      {/* <ParallaxImage className="section-margin" src="/assets/img/project/salus/salus2.png" caption="Caption #5"
                           triggerHook="top"
                           parallax={{scale: 1}} parallaxFrom={{scale: 1.3}}/> */}

      <Container className="section-margin">
        <DsnGrid
          col={1}
          colGap={50}
          rowGap={50}
          colGapTablet={30}
          rowGapTablet={30}
        >
          <img src="/assets/img/project/salus/salus2.png" alt="" />
        </DsnGrid>
      </Container>

      <NextProject heroContent={nextData} overlay={nextData.overlay} />
    </React.Fragment>
  );
};

export default Salus;
